module.exports = __webpack_public_path__ + "img/logo-white.d0a91eab.svg";